var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdvantagesIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0384 0H0V40.0387C0 62.1511 17.9258 80.0772 40.0384 80.0772C62.1511 80.0772 80.0769 62.1514 80.0769 40.0387C80.0769 17.9261 62.1511 0 40.0384 0Z",
    fill: "#DD4741"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.038 4.44824H4.44824V40.038C4.44824 59.6936 20.3824 75.6278 40.038 75.6278C59.6939 75.6278 75.6275 59.6936 75.6275 40.038C75.6275 20.3824 59.6936 4.44824 40.038 4.44824Z",
    fill: "#EC797C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M40.038 4.44824H4.44824V40.038C4.44824 59.6936 20.3824 75.6278 40.038 75.6278C59.6939 75.6278 75.6275 59.6936 75.6275 40.038C75.6275 20.3824 59.6936 4.44824 40.038 4.44824Z",
    fill: "url(#paint0_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2474 19.803C38.2474 17.2867 36.2078 15.2471 33.6914 15.2471C31.175 15.2471 29.1357 17.2867 29.1357 19.803C29.1357 22.3191 31.175 24.3587 33.6914 24.3587H38.2474V19.803Z",
    fill: "#911004"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8875 26.6367H45.0811V35.7481H59.8875V26.6367Z",
    fill: "#911004"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6914 38.0254H21.1631V63.0822H33.6914V38.0254Z",
    fill: "#911004"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6096 38.0254H45.0811V63.0822H57.6096V38.0254Z",
    fill: "#911004"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6367 19.803C49.6367 17.2867 47.5965 15.2471 45.0804 15.2471C42.5643 15.2471 40.5244 17.2867 40.5244 19.803V24.3587H45.0804C47.5965 24.3587 49.6367 22.3191 49.6367 19.803Z",
    fill: "#911004"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6909 26.6367H18.8848V35.7481H33.6909V26.6367Z",
    fill: "#911004"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8026 26.6367H35.9688V63.0828H42.8026V26.6367Z",
    fill: "#911004"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0635 23.7298H37.6195V19.1741C37.6195 16.6578 35.5799 14.6182 33.0635 14.6182C30.5471 14.6182 28.5078 16.6578 28.5078 19.1741C28.5078 21.6902 30.5471 23.7298 33.0635 23.7298Z",
    fill: "#D1DA5B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4521 26.0078H59.2586V35.1192H44.4521V26.0078Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5352 37.3975H33.0634V62.4543H20.5352V37.3975Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4521 37.3975H56.9807V62.4543H44.4521V37.3975Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8965 23.7298H44.4525C46.9685 23.7298 49.0088 21.6902 49.0088 19.1741C49.0088 16.6578 46.9685 14.6182 44.4525 14.6182C41.9364 14.6182 39.8965 16.6578 39.8965 19.1741V23.7298Z",
    fill: "#D1DA5B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2568 26.0078H33.063V35.1192H18.2568V26.0078Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3408 26.0078H42.1747V62.4539H35.3408V26.0078Z",
    fill: "#D1DA5B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 40.0378,
    y1: 4.44834,
    x2: 40.0378,
    y2: 75.6277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B0F00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantagesIcon2);
export default __webpack_public_path__ + "static/media/advantages_icon_2.bee2d5e2fbb6b4b0a735aaa4dd103b00.svg";
export { ForwardRef as ReactComponent };